<script>
import Sellingchart from "./sellingchart";
import simplebar from "simplebar-vue";
import axios from "axios";
export default {
  components: {
    Sellingchart,
    simplebar,
  },
  data() {
    return {
      currIndex: 0,
      mostProductiveOnesLoader: false,
      mostProductiveOnes: [
        {
          month: "N.A",
          data: [
          ],
        },{
          month: "N.A",
          data: [
          ],
        },{
          month: "N.A",
          data: [
          ],
        },
      ],
    };
  },
  methods: {
    changeMonth(event) {
      this.mostProductiveOnesLoader = true;
      this.currIndex = event.target.value;
      this.mostProductiveOnesLoader = false;
    },
    async getMostProductiveOnes() {
      this.mostProductiveOnesLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_most_productive",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length;i++) {
              this.mostProductiveOnes[i] = response.data.data[i];
            }
          }
        }
      } catch (error) {
        this.mostProductiveOnesLoader = false;
      }
      this.mostProductiveOnesLoader = false;
    },
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.getMostProductiveOnes();
  },
};
</script>

<template>
  <div class="card"> 
    <div class="card-body is-loading" style="height: 450px;">
      <div class="preloader-component" v-show="mostProductiveOnesLoader">
        <div class="status">
          <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      
        <div class="clearfix">
          <div class="float-end">
            <div class="input-group input-group-sm">
              <select
                class="form-select form-select-sm"
                @change="changeMonth($event)"
              >
                <option value="0" selected>{{mostProductiveOnes[0].month}}</option>
                <option value="1">{{mostProductiveOnes[1].month}}</option>
                <option value="2">{{mostProductiveOnes[2].month}}</option>
              </select>
              <label class="input-group-text">{{ $t('menuitems.dashboards.data.month') }}</label>
            </div>
          </div>
          <h4 class="card-title mb-4">{{ $t('menuitems.dashboards.data.mostProductiveOnes') }}</h4>
        </div>
        <div v-if="mostProductiveOnes[currIndex].data.length > 0">
            <simplebar style="height: 360px">
              <div class="table-responsive mt-6">
                <table class="table align-middle mb-3">
                  <tbody>
                    <tr v-for="(item, index) of mostProductiveOnes[currIndex].data" :key="index">
                      <td>
                        <h5 class="col-15 font-size-14 text-truncate mb-2">{{ item.name }}</h5>
                        <p class="col-10 font-size-13 text-truncate text-muted mb-0">{{ item.designation }}</p>
                      </td>
                      <td>
                        <Sellingchart
                          :seriesvalue="item.productivity"
                          :Chartcolor="item.color"
                        />
                      </td>
                      <td>
                        <p class="text-muted mb-1">{{ $t('menuitems.dashboards.data.productivity') }}</p>
                        <h5 class="mb-0">{{ item.productivity }} %</h5>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </simplebar>
       </div>
       <div v-if="mostProductiveOnes[currIndex].data.length <= 0">
          <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 15%;margin-left: 22%;" height="180" width="180"><br />
          <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">{{ $t('menuitems.dashboards.data.noDataFound') }}</span>
        </div>
    </div>
  </div>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>